import { createContext, ReactNode, useContext } from "react";
import { DatabaseResponseDto } from "@/gen/api/backup";
import { DeploymentResponseDto } from "@/gen/api/deploy";


export const DatabaseInfoContext = createContext<DatabaseInfoContextValue>({})

export const DatabaseInfoContextProvider = ({
  children,
  value,
}: DatabaseInfoContextOptions) => {
  return (<DatabaseInfoContext.Provider value={value}>{children}</DatabaseInfoContext.Provider>)
}

interface DatabaseInfoContextValue {
  databaseInfo?: DatabaseResponseDto,
  deploymentInfo?: DeploymentResponseDto,
}
export interface DatabaseInfoContextOptions {
  children: ReactNode,
  value: DatabaseInfoContextValue,
}

export const useDatabaseInfoContext = () => {
  return useContext<DatabaseInfoContextValue>(DatabaseInfoContext)
}

